import Oussama from '../Images/Oussama.png'
import Lotfi from '../Images/Lotfi.png'

export const testimonials = [
    {
        testimonial: 'we work together on project he was great co-worker he was really productive and he have a great programming skill in java',
        by: 'Oussama Mahdjour',
        position: 'CS Student',
        image: Oussama
    },
    {
        testimonial: 'Younes is a very good co-worker he did a great job when we worked together on the MAC science club website, the results was great, Thank’s and keep on the good work my friend',
        by: 'Lotfi Henni',
        position: 'Web Developer',
        image: Lotfi
    },
]